import React from "react";

export default function SearchIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        fill="#334155"
        fillRule="evenodd"
        d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.33a.75.75 0 11-1.06 1.06l-3.329-3.329A7 7 0 012 9z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
